import type { FunctionComponent } from 'react';

import { useGameConfig } from '../../../../config/GameConfigProvider';
import { useConfigSlice } from '../../../../store/slices/config/selectors';
import { CurrencyConnected } from '../../../currency/CurrencyConnected';
import { L12nText } from '../../../text/L12nText';
import { NavPage } from '../page/NavPage';

import styles from './NavPagesBetLimitsConnected.module.css';

export const NavPageBetLimitsConnected: FunctionComponent = () => {
  const tableName = useConfigSlice.tableName() as string;
  const tableBetLimits = useConfigSlice.tableBetLimits();
  const { betLimitContent } = useGameConfig();

  return (
    <NavPage>
      <div className={styles.navPageBetLimitsConnected__title}>
        <L12nText tk={tableName} /> <CurrencyConnected value={tableBetLimits?.min || 0} avoidTrailingZero /> -{' '}
        <CurrencyConnected value={tableBetLimits?.max || 0} avoidTrailingZero />
      </div>
      {betLimitContent}
    </NavPage>
  );
};
